// extracted by mini-css-extract-plugin
module.exports = {"container":"FlightInfo_container__TBz_D","containerFlex":"FlightInfo_containerFlex__mZESh","day":"FlightInfo_day__dAPxQ"};